import { render, staticRenderFns } from "./ContMyActivity.vue?vue&type=template&id=b49e4032&lang=pug"
import script from "./ContMyActivity.vue?vue&type=script&lang=js"
export * from "./ContMyActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b49e4032')) {
      api.createRecord('b49e4032', component.options)
    } else {
      api.reload('b49e4032', component.options)
    }
    module.hot.accept("./ContMyActivity.vue?vue&type=template&id=b49e4032&lang=pug", function () {
      api.rerender('b49e4032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ContMyActivity.vue"
export default component.exports